import React, { FC } from 'react';
import { Button, Tooltip } from '@myua/kit';
import * as sharingActions from '../actions';
import { useSelector, useDispatch } from 'react-redux';
import { getCanCreateSharingLink, getShareInProgress, getData } from '../selectors';
import { ShareContext } from '../model';
import { SharingLink } from '../../../api';
import { getAssetLabLogger } from '../../app/logs';
import { Link21 } from '@myua/icons/dist/bulk16';
import { DEMO_UNAVAILABLE_TOOLTIP } from '../../../../general/model';

export const ShareSharingButton: FC<{ sharingId: SharingLink['id'] }> = ({ sharingId }) => {
  const dispatch = useDispatch();
  const inProgress = useSelector(getShareInProgress)[ShareContext.sharing][sharingId];
  const { total } = useSelector(getData);
  const assetLabLogger = useSelector(getAssetLabLogger);

  const canShare = useSelector(getCanCreateSharingLink);

  const button = (
    <Button
      className="al-btn-blue-icon"
      loading={canShare && inProgress}
      disabled={!canShare || total.read.count === 0}
      icon={<Link21 />}
      onClick={() => {
        dispatch(sharingActions.shareSharingClicked({ sharingId }));
        assetLabLogger({
          action: 'Sharing',
          sub_action: 'Share',
          extra: { text_1: sharingId },
        });
      }}
    >
      Share
    </Button>
  );

  return canShare ? button : <Tooltip title={DEMO_UNAVAILABLE_TOOLTIP}>{button}</Tooltip>;
};
